<template>
  <div id="nom_intro_voting_not_ended">
    
    <h4>Nominations are currently closed</h4>

    <p>
      Our nomination database is bursting with all of the great nominations we received this year. Thanks to everyone who participated!
    </p>

    <div class="iframe_container">
      <iframe src="https://giphy.com/embed/l0MYt5jPR6QX5pnqM" width="100%" height="200" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><a href="https://giphy.com/gifs/party-the-office-hard-l0MYt5jPR6QX5pnqM">via GIPHY</a>
    </div>

    <p>
      <strong>BUT WAIT!</strong>
    </p>

    <p>
      It's not over yet and we still need your help to pick some winners. Use the big button below to head on over to our voting page and find out how to get your vote on.
    </p>

    <large-centered-button
    button_text="VOTE"
    icon="check-double"
    width="full"
    @button_clicked="goto_path('/vote')"
    ></large-centered-button>

  </div>
</template>

<script>
import LargeCenteredButton from '@/components/buttons/large_centered_button.vue';

export default {
  name: 'nom_intro_voting_not_ended',
  props: [
    
  ],
  data () {
    return {
      
    }
  },
  methods: {
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  computed: {
    
  },
  components: {
    LargeCenteredButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.iframe_container {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// src/features/nominate/intros/nom_intro_voting_not_ended.vue